import React, {useMemo} from 'react';
import {classes, style} from './doppe-bymo-page-footer-banner-hopp.st.css';
import {FlexLayout} from "@wix/devzai-common-client";
import {DoppeViewerAttributionLink, SourceType} from '../doppe-viewer-attribution-link/doppe-viewer-attribution-link';
import {BymoPageViewerMode, useBymoPageViewerContext} from "../bymo-page-viewer-context/bymo-page-viewer-context";
import {DoppeAppVariant, DoppeBiEmptyTargetUrl} from "../../client-server-common";
import {useDoppeViewerClientServices} from "../../client/doppe-user-app/doppe-viewer-client-services";
import {useBymoPageContextProps} from "../../doppe-sdk";
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";
import {evaluateFunction} from "@wix/devzai-utils-common";

export const DoppeBymoPageFooterBannerHopp = React.memo(function DoppeBymoPageFooterBannerHopp (props: DoppeBymoPageFooterBannerHopp.Props) {
    const {
        targetUrl = `https://www.hopp.co`,

        className,
        ...htmlAttributes
    } = props;

    const clientServices = useDoppeViewerClientServices();
    const pageViewerContext = useBymoPageViewerContext();
    const bymoPageContextProps = useBymoPageContextProps();
    const doppeViewerLocales = useDoppeViewerLocales();

    const appVariant = bymoPageContextProps.appVariant;

    const sourceType = useMemo(()=>{
        if (pageViewerContext.mode === BymoPageViewerMode.Live) {
            if(pageViewerContext.pageType === 'action-page') {
                return SourceType.LandingPage;
            }
            else if(pageViewerContext.pageType === 'speed-dial') {
                return SourceType.BioPage;
            }
            else  {
                return SourceType.PreRoll;
            }
        }

        return SourceType.LandingPage;
    }, [pageViewerContext])

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className, FlexLayout.row.alignToCenter)}
        >
            <div
                className={style(classes.messageContainer, {})}
            >
                <span>
                    {evaluateFunction(() => {
                        switch (appVariant) {
                            case DoppeAppVariant.Default: return doppeViewerLocales['createdWithHopp'];
                            case DoppeAppVariant.WixLite: return doppeViewerLocales['freemiumBanner.siteVariant.content'];
                            case DoppeAppVariant.HadreiHaredim: return doppeViewerLocales['freemiumBanner.siteVariant.content'];
                        }
                    })}
                </span>
                <span>{` `}</span>
            </div>
            <DoppeViewerAttributionLink
                className={style(classes.startNowButton, {})}
                targetUrl={targetUrl}
                sourceType={sourceType}
                onClick={() => {
                    if (pageViewerContext.mode === BymoPageViewerMode.Live) {
                        clientServices.viewerAnalyticsClient.logEvent('uouHypeBannerClicked', {
                            hypeUserId: pageViewerContext.doppeUserId,
                            linkId: pageViewerContext.linkId,
                            pageId: pageViewerContext.bymoPageId,
                            destinationUrl: bymoPageContextProps.targetUrl ?? DoppeBiEmptyTargetUrl,
                            pageType: pageViewerContext.pageType,
                        })
                    }
                }}
            >
                {`${doppeViewerLocales['tryForFree']}`}
            </DoppeViewerAttributionLink>
        </div>
    );
});

export namespace DoppeBymoPageFooterBannerHopp {

    export interface Props extends React.HTMLAttributes<any> {
        targetUrl?: string;
    }
}
